import { useContext } from "react"
import AuthContext from "store/context/PublicContext"
import { AppContext } from "store/context/AppContext"
import useCancelToken from "hooks/useCancelToken"
import OMNIX_MODULE from "constants/OMNIX_MODULE"
import { put_module_entity_action_middleware } from "services/middleware_services"
import Swal from "sweetalert2"

interface IPostCourierParams {
  body: any
}

const useCapacityResources = () => {
  const { newCancelToken, isCancel } = useCancelToken()
  const {
    user: { token },
  } = useContext(AuthContext)
  const { loading_app, set_loading_app } = useContext(AppContext)

  const put_update_max_capacity_action = async ({ body }: IPostCourierParams) => {
    try {
      return await put_module_entity_action_middleware(
        OMNIX_MODULE.OLM,
        `capacity/modify`,
        body,
        token,
        newCancelToken(),
      )
    } catch (error: any) {
      set_loading_app(false)
      Swal.fire({
        title: "Error",
        text: JSON.stringify(error?.response?.data?.message),
        icon: "error",
      })
      if (isCancel(error)) return
    }
  }

  return {
    put_update_max_capacity_action,
    loading_app,
    set_loading_app,
  }
}

export default useCapacityResources
